import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import * as yup from "yup"
import schema from "../validation/formSchema"

const initialSignUpForm = {
  email: "",
  display_name: "",
  phone: "",
  password: "",
  password_confirm: "",
  sec_question: "",
  sec_answer: ""
}

const initialFormErrors = {
  email: "",
  display_name: "",
  phone: "",
  password: "",
  password_confirm: "",
  sec_question: "",
  sec_answer: ""
}

function SignUpForm({ setUser }) {
  const [ signUpForm, setSignUpForm ] = useState(initialSignUpForm)
  const [ formErrors, setFormErrors ] = useState(initialFormErrors)
  const [ disabled, setDisabled ] = useState(true)
  const navigate = useNavigate()

  const handleSignUpChange = e => {
    const {name, value} = e.target
    yup
      .reach(schema, name)
      .validate(value)
      .then(() => {
        setFormErrors({
          ...formErrors,
          [name]: ""
        })
      })
      .catch(err => {
        setFormErrors({
          ...formErrors,
          [name]: err.errors[0]
        })
      })

    setSignUpForm({
      ...signUpForm,
      [e.target.name]: e.target.value
    })
  }

  const handleSignUpSubmit = e => {
    e.preventDefault()
    let newUser = {
      email: signUpForm.email.toLowerCase(),
      display_name: signUpForm.display_name,
      phone: signUpForm.phone,
      password: signUpForm.password,
      sec_question: signUpForm.sec_question,
      sec_answer: signUpForm.sec_answer
    }


    axios.post("https://roma-be.herokuapp.com/api/auth/register", newUser)
      .then(res => {
        setUser(res)
        localStorage.setItem("token", res.data.token)
        navigate("/order/dining")
      })
      .catch(() => {
        return
      })
  }

  useEffect(() => {
    schema.isValid(signUpForm).then(valid => {
      setDisabled(!valid)
    })
  }, [signUpForm])

  return (
    <div className="sign-up-container">
      <span className="register-note">For pick-up or dine-in, order right here!</span>
      <h1 className="register-h1" >Sign Up</h1>
            
      <form onSubmit={handleSignUpSubmit} className="sign-up-form">
        {signUpForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="text" 
          name="email" 
          placeholder="Email" 
          onChange={handleSignUpChange} 
          value={signUpForm.email} 
        />

        {signUpForm.display_name ?
          <span className="su-errors">{formErrors.display_name}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="text" 
          name="display_name" 
          placeholder="Display Name" 
          onChange={handleSignUpChange} 
          value={signUpForm.display_name} 
        />

        {signUpForm.phone ?
          <span className="su-errors">{formErrors.phone}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="phone" 
          name="phone" 
          placeholder="Phone # (optional)" 
          onChange={handleSignUpChange} 
          value={signUpForm.phone} 
        />

        {signUpForm.password ?
          <span className="su-errors">{formErrors.password}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="password" 
          name="password" 
          placeholder="Password" 
          onChange={handleSignUpChange} 
          value={signUpForm.password} 
        />

        
        {signUpForm.password_confirm ?
          <span className="su-errors">{formErrors.password_confirm}</span>
        : null}
        {signUpForm.password_confirm ?
          signUpForm.password_confirm !== signUpForm.password ?
            <span className="su-errors">*Passwords must match</span>
          : null
        : null}
        <input 
          className="sign-up-form-input"
          type="password" 
          name="password_confirm" 
          placeholder="Confirm Password" 
          onChange={handleSignUpChange} 
          value={signUpForm.password_confirm} 
        />

        {signUpForm.sec_question ?
          <span className="su-errors">{formErrors.sec_question}</span>
        : null}
        <select name="sec_question" type="dropdown" className="sign-up-form-input" onChange={handleSignUpChange}>
          <option value="">Select a Secuirty Question</option>
          <option value="What is your mother's maiden name?">What is your mother's maiden name?</option>
          <option value="What was your first pet's name?">What was your first pet's name?</option>
          <option value="What was the address of your childhood home?">What was the address of your childhood home?</option>
          <option value="What was the name of your elemetary school?">What was the name of your elemetary school?</option>
          <option value="What was your first grade teacher's name?">What was your first grade teacher's name?</option>
        </select>

        {signUpForm.sec_answer ?
          <span className="su-errors">{formErrors.sec_answer}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="password" 
          name="sec_answer" 
          placeholder="Security Question Answer" 
          onChange={handleSignUpChange} 
          value={signUpForm.sec_answer}
        />

        {signUpForm.password_confirm ?
          signUpForm.password_confirm === signUpForm.password ?
            <button disabled={disabled} className="sign-up-submit-button">Submit</button>
          : <button disabled={true} className="sign-up-submit-button">Submit</button>
        : <button disabled={true} className="sign-up-submit-button">Submit</button>}
        
      </form>
    </div>
  )
}

export default SignUpForm
